<template>
  <div class="login">
    <el-row style="margin-top: 40px;">
      <el-col
        class="hidden-xs-only"
        :sm="3"
        :md="6"
        :lg="8"
        :xl="9"
      >
        &nbsp;
      </el-col>
      <el-col
        :xs="24"
        :sm="18"
        :md="12"
        :lg="8"
        :xl="6"
      >
        <transition name="el-fade-in">
          <el-card v-show="page === 'reset-password'">
            <div
              slot="header"
              class="clearfix"
            >
              <span>Elfelejtett jelszó</span>
              <el-button
                style="float: right; margin-top: -5px;"
                size="small"
                @click="openLogin"
                icon="el-icon-back"
              >
                Vissza
              </el-button>
            </div>
            <el-form
              :model="resetPassword"
              @submit.prevent.native="reset"
              :rules="resetRules"
              status-icon
              hide-required-asterisk
            >
              <el-form-item
                label="Felhasználónév"
                prop="username"
              >
                <el-input
                  v-model="resetPassword.username"
                  @keyup.enter.native="reset"
                />
              </el-form-item>
            </el-form>
            <div style="margin-top: 20px;">
              <el-button
                :loading="loading"
                @click="reset"
                type="primary"
                style="width: 100%;"
              >
                Jelszó lecserélése
              </el-button>
            </div>
          </el-card>
        </transition>
        <transition name="el-fade-in">
          <el-card v-show="page === 'login'">
            <div
              slot="header"
              class="clearfix"
            >
              <span>Bejelentkezés</span>
            </div>
            <el-form
              :model="formDetails"
              :rules="rules"
              @submit.prevent.native="login"
              status-icon
              hide-required-asterisk
            >
              <el-form-item
                label="Felhasználónév"
                prop="username"
              >
                <el-input
                  v-model="formDetails.username"
                  @keyup.enter.native="login"
                />
              </el-form-item>
              <el-form-item
                label="Jelszó"
                style="margin-bottom: 10px;"
                prop="password"
              >
                <el-input
                  v-model="formDetails.password"
                  type="password"
                  show-password
                  @keyup.enter.native="login"
                />
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    prop="rememberMe"
                  >
                    <el-switch
                      v-model="formDetails.rememberMe"
                      active-text="Emlékezz rám"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  style="text-align: right;"
                >
                  <el-button type="text" @click="openResetPassword">
                    Elfelejtett jelszó
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
            <div style="margin-top: 20px;">
              <el-button
                :loading="loading"
                @click="login"
                type="primary"
                style="width: 100%;"
              >
                Bejelentkezés
              </el-button>
            </div>
          </el-card>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: null,
      show: false,
      loading: false,
      resetRules: {
        email: {
          required: true,
          message: 'E-mail megadása kötelező',
          trigger: 'change',
        },
      },
      rules: {
        username: {
          required: true,
          message: 'Felhasználónév megadása kötelező',
          trigger: 'change',
        },
        password: {
          required: true,
          message: 'Jelszó megadása kötelező',
          trigger: 'change',
        },
      },
      formDetails: {
        username: '',
        password: '',
        rememberMe: false,
      },
      resetPassword: {
        username: '',
      },
    };
  },
  mounted() {
    setTimeout(() => this.page = 'login', 200);
  },
  methods: {
    openResetPassword() {
      this.page = null;
      setTimeout(() => this.page = 'reset-password', 300);
    },
    openLogin() {
      this.page = null;
      setTimeout(() => this.page = 'login', 300);
    },
    async login() {
      this.loading = true;
      try {
        await this.$store.dispatch('auth/login', this.formDetails);
        await this.$store.dispatch('auth/fetchUser');
        this.$router.push({ name: 'dashboard' });
      } catch (e) {
      }
      this.loading = false;
    },
    async reset() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        await axios.post('api/reset-password', { username: this.resetPassword.username });
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
  .login {
    position: fixed;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #2b5876;
    background: -webkit-linear-gradient(to right, #4e4376, #2b5876);
    background: linear-gradient(to right, #4e4376, #2b5876);
  }
</style>
